import { render, staticRenderFns } from "./DeviceIncreasedPlay.vue?vue&type=template&id=50d68c82&scoped=true"
import script from "./DeviceIncreasedPlay.vue?vue&type=script&lang=js"
export * from "./DeviceIncreasedPlay.vue?vue&type=script&lang=js"
import style0 from "./DeviceIncreasedPlay.vue?vue&type=style&index=0&id=50d68c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d68c82",
  null
  
)

export default component.exports